<template>
  <div class="document-content-info-view">
    <!-- ヘッダー -->
    <div
      class="flex flex-wrap header-area p-4 align-middle w-full justify-between"
    >
      <div class="flex items-center">
        <div class="filename truncate ...">
          <vx-tooltip
            :text="name"
            class="min-w-0 truncate ..."
          >
            <span>{{ name }}</span>
          </vx-tooltip>
        </div>
        <awe-icon
          v-if="isStarIcon"
          name="star"
          scale="1"
          class="important-icon ml-2"
        />
      </div>

      <div class="flex">
        <feather-icon
          class="action-button-icon rounded cursor-pointer w-6 h-6"
          svgClasses="h-4 w-6"
          icon="XIcon"
          @click.stop="toggleCloseButton()"
        ></feather-icon>
      </div>
    </div>

    <!-- ボディ -->
    <vue-perfect-scrollbar :style="{ height: scrollHeight }">
      <div class="flex thumbnail_area place-items-center justify-center p-4">
        <div class="place-items-center justify-center flex flex-warp">
          <div class="flex justify-center items-center">
            <document-thumbnail-view :document="document" />
          </div>
        </div>
      </div>

      <vs-divider class="px-2 m-0"></vs-divider>

      <div class="content-area p-4">
        <div class="aisea-text-14-400-black mb-3">
          <span>書類情報</span>
        </div>

        <div
          class="flex items-center justify-between aisea-text-12-400-gray mb-3"
        >
          <span>種類</span>
          <span>{{ kind }}</span>
        </div>
        <div
          class="flex items-center justify-between aisea-text-12-400-gray mb-3"
        >
          <span>サイズ</span>
          <span>{{ size }}</span>
        </div>
        <div
          class="flex items-center justify-between aisea-text-12-400-gray mb-3"
        >
          <span>場所</span>
          <div class="w-4/5 break-words text-right">
            {{ filepath }}
          </div>
        </div>
        <div
          class="flex items-center justify-between aisea-text-12-400-gray mb-3"
        >
          <span>更新日</span>
          <span>{{ updated }}</span>
        </div>
        <div
          class="flex items-center justify-between aisea-text-12-400-gray mb-3"
        >
          <span>作成日</span>
          <span>{{ created }}</span>
        </div>
        <div
          class="flex items-center justify-between aisea-text-12-400-gray mb-3"
        >
          <span>重要書類</span>
          <span>{{ importantFileText }}</span>
        </div>
      </div>
    </vue-perfect-scrollbar>
  </div>
</template>

<script>
import { ColorMixin, DocumentMixin } from "@/mixins";
import { createNamespacedHelpers } from "vuex";
import { UnitUtil } from "@/utils";
import moment from "moment";
import DocumentThumbnailView from "./components/DocumentThumbnailView"
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

const {
  mapActions: mapActionsOfEnterpriseDocumentManager,
  mapMutations: mapMutationsOfEnterpriseDocumentManager,
  mapState: mapStateOfEnterpriseDocumentManager
} = createNamespacedHelpers("enterpriseDocumentManager");



export default {
  mixins: [ColorMixin, DocumentMixin],
  components: { DocumentThumbnailView, VuePerfectScrollbar },
  computed: {
    ...mapStateOfEnterpriseDocumentManager(["selectedDocument", "documentRootPath"]),
    name () {
      if (!this.selectedDocument) return ""
      if (!Object.prototype.hasOwnProperty.call(this.selectedDocument, "name")) return ""
      return this.selectedDocument.name
    },
    kind () {
      if (!this.selectedDocument) return ""
      return this.getDocumentMimeName(this.selectedDocument.type)
    },
    size () {
      if (!this.selectedDocument) return "";
      return UnitUtil.formatBytes(this.selectedDocument.size, 0)
    },
    filepath () {
      if (!this.selectedDocument) return ""
      if (!Object.prototype.hasOwnProperty.call(this.selectedDocument, "path")) return ""
      return `/${this.selectedDocument.path.replace(this.documentRootPath, "").replace(this.selectedDocument.name, "")}`;
    },
    updated () {
      if (!this.selectedDocument) return ""
      return moment(this.selectedDocument.updated).format("YYYY-MM-DD kk:mm")
    },
    created () {
      if (!this.selectedDocument) return ""
      return moment(this.selectedDocument.created).format("YYYY-MM-DD kk:mm")
    },
    fileIcon () {
      if (!this.selectedDocument) return "FileIcon"
      return this.getDocumentMimeIcon(this.selectedDocument.type)
    },
    document () {
      if (!this.selectedDocument) return {};
      return this.selectedDocument;
    },
    scrollHeight () {
      return `${this.$store.state.windowHeight - 240}px`
    },
    isStarIcon () {
      if (!this.selectedDocument) return false;
      return this.selectedDocument.important
    },
    importantFileText(){
      return this.isStarIcon ? "設定済み" : "未設定";
    }
  },
  methods: {
    ...mapMutationsOfEnterpriseDocumentManager(["SET_CONTENT_INFO_SIDEBAR_ACTIVE"]),
    ...mapActionsOfEnterpriseDocumentManager(["sliceRootPath"]),
    toggleCloseButton () {
      this.SET_CONTENT_INFO_SIDEBAR_ACTIVE(false)
    }
  },

}
</script>

<style lang="scss">
@import "src/assets/scss/aisea/variables";
@import "src/assets/scss/vuexy/variables";

.document-content-info-view {
  .header-area {
    background: $aisea-white;

    .filename {
      max-width: 300px;
    }
  }

  .thumbnail_area {
    .icon-img {
      color: $aisea-gray;
    }
  }

  .action-button-icon:hover {
    background: $aisea-light-gray;
  }
}
</style>